import { render } from "./DetailedSpendTypesFilters.vue?vue&type=template&id=0b4562f0"
import script from "./DetailedSpendTypesFilters.vue?vue&type=script&lang=js"
export * from "./DetailedSpendTypesFilters.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DetailedSpendTypesFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b4562f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b4562f0', __exports__)) {
    console.log('reload')
    api.reload('0b4562f0', __exports__)
  }
  
  module.hot.accept("./DetailedSpendTypesFilters.vue?vue&type=template&id=0b4562f0", () => {
    console.log('re-render')
    api.rerender('0b4562f0', render)
  })

}


export default __exports__